var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormPublish" } }, [
    _c("div", { staticClass: "settings-menu" }, [
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _vm.activeItem === 0 },
          on: {
            click: function ($event) {
              return _vm.setActive(0)
            },
          },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("link")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.shareFast"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.shareFastDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item",
          class: { active: _vm.activeItem === 1 },
          on: {
            click: function ($event) {
              return _vm.setActive(1)
            },
          },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("code")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.add"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.addDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 2 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("group")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.assignForm"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.assignFormDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 3 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("mail")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.emails"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.emailsDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 4 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("storage")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.prefill"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.prefillDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 5 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("picture_as_pdf")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.pdf"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.pdfDesc"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "menu-item disabled",
          class: { active: _vm.activeItem === 6 },
        },
        [
          _c("i", { staticClass: "icon md-icon" }, [_vm._v("layers")]),
          _vm._v(" "),
          _c("div", { staticClass: "menu-text" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.platforms"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.$t("form.formPublish.platformsDesc"))),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm.activeItem === 0
          ? _c("ShareFast", {
              attrs: { formId: _vm.formId, siteId: _vm.siteId },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.activeItem === 1
          ? _c("FormAdd", {
              attrs: { "form-id": _vm.formId, "site-id": _vm.siteId },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }